import React, { useState } from "react";
import { ParameterType } from "../../store/types/configuration";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "../mui/Button";
import Stack from "../mui/Stack";
import Tab from "../mui/Tab";
import Tabs from "../mui/Tabs";
import { SxProps, Theme, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ImageComponent from "../mui/Image";
import Typography from "../mui/Typography";

interface Props {
  scoreTabs: ParameterType[];
  isLoadingScoreTabs: boolean;
  handleTabChange: (parameterTypeId: number) => void;
  handleAddParameterBtn: () => void;
  activeTab: number | null;
  setActiveTab: any;
  handleEditParameterBtn: any;
  canWrite:boolean
}

const tabIndicatorStyles: SxProps<Theme> = {
  bgcolor: "transparent",
  height: "0px",
};

const ScoreManagementTabs: React.FC<Props> = ({
  scoreTabs,
  isLoadingScoreTabs,
  handleTabChange,
  handleAddParameterBtn,
  activeTab,
  setActiveTab,
  handleEditParameterBtn,
  canWrite
}) => {
  if (isLoadingScoreTabs) {
    return <CircularProgress />;
  }

  return (
    <Stack
      direction="row"
      sx={{ justifyContent: "space-between", alignItems: "center" }}
    >
      <Stack direction="row" alignItems="center" width={"100%"}>
        <Tabs
          value={activeTab}
          onChange={(event: React.SyntheticEvent, newValue: number) =>
            setActiveTab(newValue)
          }
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            sx: tabIndicatorStyles,
          }}
          sx={{
            "& .MuiTabs-scroller": {
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          {scoreTabs.map((tab) => (
            <Tab
              key={tab.parameterTypeId}
              label={
                <Stack direction="row" alignItems="center">
                  <Typography
                    sx={{
                      whiteSpace: "nowrap",
                      fontWeight: "600",
                      fontSize: "15px",
                    }}
                  >
                    {tab.parameterTypeName}
                  </Typography>
                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ marginLeft: "-10px" }}
                  >
                    <ImageComponent
                      src="/assets/images/icon/dot.svg"
                      alt="dot"
                      sx={{ height: "5px", width: "5px", marginRight: "-10px" }}
                    />
                    <Typography sx={{ fontWeight: "600", fontSize: "15px" }}>
                      {tab.parameterTypeName ===
                      "Programme Performance Parameters"
                        ? ` ${tab?.percentage}%`
                        : ` ${tab?.percentage}%`}
                    </Typography>
                  </Stack>
                </Stack>
              }
              onClick={() => handleTabChange(tab.parameterTypeId)}
              sx={{
                transition: "color 0.3s, background-color 0.3s",
                border: "1px solid #AFAFAF",
                textTransform: "capitalize",
                borderRadius: "20px",
                bgcolor: "#FFFFFF",
                color: "#AFAFAF",
                marginRight: "20px",
                fontWeight: 600,
                minHeight: "27px",
                maxHeight: "34px",
                height: "40px",
                justifyContent: "center",
                display: "flex",
                alignItems: "flex-start",
                paddingRight: "50px !important",

                "&.Mui-selected": {
                  fontWeight: 700,
                  color: "#242424",
                  backgroundColor: "#FFF1B7",
                  border: "1px solid #997906",
                },
              }}
            />
          ))}
        </Tabs>
        <Button
          onClick={handleEditParameterBtn}
          disabled={!canWrite}
          sx={{
            border: "1px solid #997906",
            backgroundColor: "#FFFFFF",
            borderRadius: "20px",
            padding: "8px 0px",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          }}
        >
          <ImageComponent
            src="/assets/images/icon/editIcon.svg"
            alt="editPen"
          />
        </Button>
      </Stack>

      {/* <Button
        startIcon={<AddIcon />}
        onClick={handleAddParameterBtn}
        disabled={!canWrite}
        sx={{
          border: "1px solid #8D8D8D",
          backgroundColor: "#fff",
          "&:hover": {
            backgroundColor: "#ededed",
          },
          borderRadius: "8px",
          textTransform: "capitalize",
          boxShadow: "none !important",
        }}
      >
        Add Parameter
      </Button> */}
    </Stack>
  );
};

export default ScoreManagementTabs;
